var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 305.406 305.406",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M123.901,137.703c0,4.971,4.029,9,9,9h80c4.971,0,9-4.029,9-9s-4.029-9-9-9h-80 C127.93,128.703,123.901,132.732,123.901,137.703z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.901,177.686h-80c-4.971,0-9,4.029-9,9c0,4.971,4.029,9,9,9h80c4.971,0,9-4.029,9-9 C221.901,181.715,217.872,177.686,212.901,177.686z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.901,226.669h-80c-4.971,0-9,4.029-9,9s4.029,9,9,9h80c4.971,0,9-4.029,9-9S217.872,226.669,212.901,226.669z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.901,
    cy: 137.703,
    r: 9.396
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.901,
    cy: 186.686,
    r: 9.396
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.901,
    cy: 235.669,
    r: 9.396
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.067,70.613L199.091,2.636C197.402,0.948,195.113,0,192.727,0H44.703c-4.971,0-9,4.029-9,9v287.406 c0,4.971,4.029,9,9,9h216c4.971,0,9-4.029,9-9V76.977C269.703,74.59,268.755,72.301,267.067,70.613z M199.727,28.728 l41.249,41.249h-41.249V28.728z M251.703,287.406h-198V18h128.023v60.977c0,4.971,4.029,9,9,9h60.977V287.406z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.4cc6d7602cf7007c108545cfc68c6b70.svg";
export { ForwardRef as ReactComponent };